/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';

import template from './tcf-page.component.html';
import {TcfService} from '../../../components/api/resources/resource/tcf.service';

@Component({
  standalone: false,
  selector: 'adn-tcf-page',
  template
})
export class TcfPageComponent {
  tcf = '';
  gdpr = 'GDPR_ON';
  auTagId = '';
  doing = false;
  gdprResults: any = null;

  constructor(@Inject(TcfService) private readonly TCF: any) {
  }

  findPurposes(): void {
    this.doing = true;
    const gdprParam = this.gdpr === 'GDPR_AD_UNIT' && this.auTagId ? this.auTagId : (this.gdpr || 0);
    this.TCF.checkTcf(gdprParam, this.tcf).then((data: any) => {
      this.gdprResults = data;
      this.doing = false;
    });
  }
}
